import { motion } from "framer-motion";
import { lineMask, stagger } from "@/lib/motion";

// Masked, line-by-line reveal for editorial serif headings.
export default function RevealText({
  lines,
  className = "",
  as: Tag = "h1",
  delay = 0,
  stagger: st = 0.12,
  animateOnView = false,
  testId,
}) {
  const container = stagger(delay, st);
  const trigger = animateOnView
    ? { whileInView: "show", viewport: { once: true, amount: 0.5 } }
    : { animate: "show" };

  return (
    <Tag className={className} data-testid={testId}>
      <motion.span
        className="block"
        variants={container}
        initial="hidden"
        {...trigger}
      >
        {lines.map((line, i) => (
          <span key={i} className="block overflow-hidden pb-[0.18em] -mb-[0.12em]">
            <motion.span className="block leading-[1.15] will-change-transform" variants={lineMask}>
              {line}
            </motion.span>
          </span>
        ))}
      </motion.span>
    </Tag>
  );
}
